var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"narrow-content"},[_c('h2',{staticClass:"heading animate-box",attrs:{"data-animate-effect":"fadeInLeft"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"row"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }